import { Injectable } from '@angular/core';
import { StateService } from '../state.service';
import { Observable, throwError } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../../shared/UI/confirmation-dialog/confirmation-dialog.component';
import { AlertDialogComponent } from '../../shared/UI/alert-dialog/alert-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import * as moment from 'moment';
import { AppConfig } from '../../models/appConfig.model';
import { EmailDetails } from '../../models/email.model';
import { EmailService } from '../email.service';

@Injectable()
export class UtilityService {


  constructor(private _emailService: EmailService,
    private _dialog: MatDialog,
    private _router: Router,) {

  }

  public static readonly StartDateFormat: string = "DD-MMM-YYYY 00.00.00";
  public static readonly EndDateFormat: string = "DD-MMM-YYYY 23.59.59";

  private static _appConfig: AppConfig = { homeURL: '', portalURL: '' };

  public static get AppConfig(): AppConfig {
    return this._appConfig
  }

  public static set AppConfig(value: AppConfig) {
    this._appConfig = value;
  }

  // Create a deep copy of object 
  public static clone<T>(a: T): T {
    return JSON.parse(JSON.stringify(a));
  }

  public static validateDates(sDate: moment.Moment, eDate: moment.Moment): string {
    let sRetVal: string = '';

    if (sDate && eDate) {
      if (sDate > eDate) {
        sRetVal = 'greater';
      }
    } else {
      sRetVal = 'empty';
    }

    return sRetVal;
  }

  public handleErrorResponse(err: HttpErrorResponse) {
    if (err.status == 401) {
      this._router.navigate(['/unauthorized']);
    } else if (err.status == 403) {
      this._router.navigate(['/access-denied']);
    } else {
      console.error(err);
    }
  }

  public handleError(statusCode: number, errorMsg: string) {
    if (statusCode == 401) {
      this._router.navigate(['/unauthorized']);
    } else if (statusCode == 403) {
      this._router.navigate(['/access-denied']);
    } else {
      console.error(statusCode, errorMsg);
    }
  }

  public showConfirmMsg(title: string, msg: string): Observable<any> {

    const dialogRef = this._dialog.open(ConfirmationDialogComponent, {
      width: 'auto',
      disableClose: true,
      data: {
        header: title,
        content: msg
      }
    });

    return dialogRef.afterClosed();
  }

  public showAlertMsg(title: string, msg: string): Observable<boolean> {

    const dialogRef = this._dialog.open(AlertDialogComponent, {
      width: 'auto',
      disableClose: true,
      data: {
        header: title,
        content: msg
      }
    });

    return dialogRef.afterClosed();
  }

  public getObjectPropertiesInstring(obj: any): string {
    let objectPropertyString = "";
    if (obj == null) {
      return "";
    }
    Object.keys(obj)
      .forEach(key => {
        if (obj.hasOwnProperty(key)) {
          if (Array.isArray(obj[key])) {
            if (obj[key] != null) {
              if (obj[key].length > 0) {
                console.log(obj[key]);
                obj[key].forEach(i => {
                  objectPropertyString = objectPropertyString + this.getObjectPropertiesInstring(i);
                }
                );
              }
              else {

                objectPropertyString = objectPropertyString + key + " - <br>";
              }
            }
          }
          else {
            if (typeof obj[key] == "object") {
              if (obj[key] != null) {
                objectPropertyString = objectPropertyString + this.getObjectPropertiesInstring(obj[key]);
              }
              else {
                objectPropertyString = objectPropertyString + key + " - <br>";
              }
            }
            else {
              objectPropertyString = objectPropertyString + key + " - " + obj[key] + "<br>";
            }
          }
        }
      })
    return objectPropertyString;
  }

  public handleErrors(err: HttpErrorResponse, object: any = null, parameters: string = "", encryptedUser = "", sourceService: string = "", sourceMethodName: string = "") {

    let objectPropertiesInstring: string = "";

    if (object != null) {
      objectPropertiesInstring = this.getObjectPropertiesInstring(object);
      objectPropertiesInstring = objectPropertiesInstring + "<br> Json string" + JSON.stringify(object);
    }
    var stackStrace = err.error ? err.error.StackTraceString : "";
    let msg: string = err.message + "<br>" +
      (err.error && err.error.Message != null ? err.error.Message + "<br><hr>" : "") +
      stackStrace + "<br><hr>" +
      parameters + "<br><hr>" +
      objectPropertiesInstring;

    let email: EmailDetails = {
      subject: "Client - [ENV] - " + sourceService + "." + sourceMethodName,
      message: msg,
      toList: "",
      from: ""
    }
    this._emailService.sndEmailAsync(encryptedUser, email, 0, null, 0);
    return throwError(new HttpErrorResponse({
      error: { error: 'There is a problem with the Invent Help Contract Set up  service. We are notified & working on it. Please try again later.' },
      headers: err.headers,
      status: err.status,
      statusText: err.statusText,
      url: err.url
    }));
  }
}
